var _googleTagTrackerLoaded = false;

/**
 * An object to manage Google Tag as a TrackerManager plugin
 * @constructs GoogleTagTracker
 * @memberof Class
 * @author Andreï Cavoleau
 */
function GoogleTagTracker(config) {
	this.account = config.account;
	this.anonymize = config.anonymize === 'true';

	// The tracker name should be only lowercase chars and numbers
	this.trackerName = 'tracker' + this.account.replace(/-/gi, '').toLowerCase();
	this.loadTracker();
}

GoogleTagTracker.prototype.isLoaded = function () {
	return _googleTagTrackerLoaded;
}

/**
 * Load the googleTag tracker
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.loadTracker = function () {
	if (_googleTagTrackerLoaded) {
		return;
	}

	var libraryUrl = (this.anonymize ?
		'https://gtm.zone-secure.net/gtag/js?id=' :
		'https://www.googletagmanager.com/gtag/js?id=') + this.account;

	var s = document.createElement("script");
	s.src = libraryUrl;
	s.setAttribute('async', '');
	document.head.append(s);

	window.dataLayer = window.dataLayer || [];

	// Firebase Tracking
	this.logEvent = function (name, params) {
		if (!name) {
			return;
		}

		if (window.AnalyticsWebInterface) {
			// Call Android interface
			window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
		} else if (window.webkit &&
			window.webkit.messageHandlers &&
			window.webkit.messageHandlers.firebase) {
			// Call iOS interface
			var message = {
				command: 'logEvent',
				name: name,
				parameters: params
			};
			window.webkit.messageHandlers.firebase.postMessage(message);
		} else {
			// No Android or iOS interface found
		}
	}

	this.setUserProperty = function (name, value) {
		if (!name || !value) {
			return;
		}

		if (window.AnalyticsWebInterface) {
			// Call Android interface
			window.AnalyticsWebInterface.setUserProperty(name, value);
		} else if (window.webkit &&
			window.webkit.messageHandlers &&
			window.webkit.messageHandlers.firebase) {
			// Call iOS interface
			var message = {
				command: 'setUserProperty',
				name: name,
				value: value
			};
			window.webkit.messageHandlers.firebase.postMessage(message);
		} else {
			// No Android or iOS interface found
		}
	}

	this.gtag = function () {
		dataLayer.push(arguments);
		switch (arguments[0]) {
			case 'set':
				var params = arguments[2];
				if (params) {
					Object.keys(params).forEach(function (name) {
						this.setUserProperty(name, params[name]);
					}.bind(this));
				}
				break;
			case 'event':
				this.logEvent(arguments[1], arguments[2]);
				break;
		}
	}

	this.gtag('js', new Date());

	this.createTracker();

	_googleTagTrackerLoaded = true;
};

/**
 * Create the analytics tracker
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.createTracker = function () {
	// To use the GA4 Debug View add the following property to the parameters object - debug_mode: true,
	this.gtag('config', this.account, {
		send_page_view: false,
		anonymize_ip: this.anonymize,
	});
};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.trackPage = function (page, url, title) {
	this.gtag('event', 'page_view', {
		page_title: title,
		page_location: url,
		page_path: page,
		send_to: this.account
	});
};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.trackEvent = function (category, action, label, value) {
	this.gtag('event', category, {
		'wpAction': action,
		'wpLabel': label,
		'wpValue': value
	});

};

GoogleTagTracker.prototype.trackProperty = function (name, value) {
	var params = {};
	params[name] = value;
	this.gtag('set', 'user_properties', params);
};

module.exports = GoogleTagTracker;



//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/googleTagTracker.js
// module id = 796
// module chunks = 0